
const RULES = {
  ENTITY_NAME: {
    pattern: /^[a-zA-Z0-9\s,'.&:;\-#+]{1,255}$/,
    message: "The only special characters allowed: , . & : ; - # + '"
  }
}

export default RULES
